import React from 'react';
import PropTypes from 'prop-types';
import { MessageDescriptorPropType } from '../../prop-types/intl';
import { Button } from 'ui-components/components/button';
import { Tooltip } from 'ui-components/components/tooltip';

import style from './reusable-grid-button.module.css';
import { FormattedMessage } from 'react-intl';

export const ButtonWithTooltip = ({ tooltip = '', disable = false, theme = '', messageDescriptor = null, onClick }) => {
  return (
    <Tooltip position='bottom' text={tooltip}>
      <div className={style['active-manual-store-tooltip']}>
        <FormattedMessage {...messageDescriptor}>
          {(buttonText) => {
            return (
              <Button className={style['reusable-button']} disabled={disable} onClick={onClick} theme={theme}>
                {buttonText}
              </Button>
            );
          }}
        </FormattedMessage>
      </div>
    </Tooltip>
  );
};

ButtonWithTooltip.propTypes = {
  messageDescriptor: MessageDescriptorPropType,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  theme: PropTypes.string,
  disable: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
